import PropTypes from 'prop-types';
import cx from 'classnames';
import NewsCard from './NewsCard'; // Ajusta la ruta según dónde lo pongas

const GridTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  const isEven = items.length % 2 === 0;

  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';
  if (href) {
    link = (
      <a href={href} className="footer-link">
        {linkTitle || href}
      </a>
    );
  }

  return (
    <>
      <div
        className={cx('items', { 'items-even': isEven, 'items-odd': !isEven })}
      >
        {items.map((item) => (
          <div className="listing-item" key={item['@id']}>
            <NewsCard item={item} isEditMode={isEditMode} />
          </div>
        ))}
      </div>
      {link && <div className="footer">{link}</div>}
    </>
  );
};

GridTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default GridTemplate;
